export default [
    {
        //职员
        path: "/employee",
        name: "employee",
        component: () => import('../components/baseinfo/employee'),
        meta: { keepAlive: false }
    },
    {
        //仓库
        path: "/store",
        name: "store",
        component: () => import('../components/baseinfo/store'),
        meta: { keepAlive: false }
    },
    {
        //客户
        path: "/custom",
        name: "custom",
        component: () => import('../components/baseinfo/custom'),
        meta: { keepAlive: false }
    },
    {
        //供应商
        path: "/supplier",
        name: "supplier",
        component: () => import('../components/baseinfo/supplier'),
        meta: { keepAlive: false }
    },
    {
        //商品
        path: "/goods",
        name: "goods",
        component: () => import('../components/baseinfo/goods'),
        meta: { keepAlive: false }
    },
    {
        //商品分类
        path: "/goodsclass",
        name: "goodsclass",
        component: () => import('../components/baseinfo/goods-class'),
        meta: { keepAlive: false }
    },
    {
        //商品新增
        path: "/goods/add",
        name: "addgoods",
        component: () => import('../components/baseinfo/edit-goods'),
        meta: { keepAlive: true }
    },
    {
        //商品编辑
        path: "/goods/edit",
        name: "editgoods",
        component: () => import('../components/baseinfo/edit-goods'),
        meta: { keepAlive: true }
    },
    {
        //导入商品
        path: "/goods/import",
        name: "importgoods",
        component: () => import('../components/importexcel/import-goods'),
        meta: { keepAlive: false }
    },
    {
        //导入客户
        path: "/custom/import",
        name: "importcustom",
        component: () => import('../components/importexcel/import-custom'),
        meta: { keepAlive: false }
    },
    {
        //导入供应商
        path: "/supplier/import",
        name: "importsupplier",
        component: () => import('../components/importexcel/import-supplier'),
        meta: { keepAlive: false }
    }
]



// WEBPACK FOOTER //
// ./src/router/baseinfo-router.js